export const STEPS = {
  USER_INFORMATION: 'USER_INFORMATION',
  PIN_VERIFICATION: 'PIN_VERIFICATION',
  EMAIL_REGISTRATION: 'EMAIL_REGISTRATION',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  EMAIL_VERIFICATION_SENT: 'EMAIL_VERIFICATION_SENT',
};
